/* eslint-disable */
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

import { createApp } from "vue"
import { createI18n } from "vue-i18n"
import { createGtm } from "@gtm-support/vue-gtm"
import App from "./App.vue"
import router from "./router/index.js"
import { ALLOWED_LANGS } from "@/constants/allowed_langs"
import { TRANSLATIONS_MAPPER } from "@/constants/translations_mapper"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "../assets/scss/main.scss"
import * as Sentry from "@sentry/vue"
// import dict from "./translates/generated/xx-XX/message.xx_XX.json";

/* init translations */
let urlPathname = window.location.pathname
let urlLanguage = urlPathname.split("/")[1] || "cs"
if (!ALLOWED_LANGS.includes(urlLanguage)) {
  urlLanguage = "cs"
}

const fallbackLanguage = "xx"

const i18n = createI18n({
  locale: urlLanguage,
  fallbackLocale: fallbackLanguage,
  messages: loadLocaleMessages(),
})

/* init VUE application */
const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://c5ebaa64fc753eb3fb476335e9e5eb66@sentry.packetery.com/46",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/claims\.packeta\.com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

/* eslint-disable */
app.use(router)
app.use(i18n)
app.use(
  createGtm({
    id: window.env.VUE_APP_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    // queryParams: {
    //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    //   gtm_preview: 'env-4',
    //   gtm_cookies_win: 'x',
    // },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    // nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: window.env.VUE_APP_GTM_ENABLED === "1", // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }),
)
app.mount("#app")

function loadLocaleMessages() {
  const messages = {}
  const fileName = "web"
  ALLOWED_LANGS.forEach((lang) => {
    // try to load language translations
    try {
      messages[lang] = require("../src/translates/" +
        TRANSLATIONS_MAPPER[lang] +
        "/" +
        fileName +
        "." +
        TRANSLATIONS_MAPPER[lang].replace("-", "_") +
        ".json")
    } catch (e) {
      console.log(
        "Language file for '" +
          lang +
          "' does not exist. Create it in TranslationHUB.",
      )
    }
  })

  // default fallback language
  messages[fallbackLanguage] = require("../src/translates/" +
    TRANSLATIONS_MAPPER[fallbackLanguage] +
    "/" +
    fileName +
    "." +
    TRANSLATIONS_MAPPER[fallbackLanguage].replace("-", "_") +
    ".json")

  return messages
}
